export default __webpack_public_path__ + "static/media/s.811a9bcb.svg";